import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';

const StyledImage = styled('img')(({ theme }) => ({
  height: '40px',
  [theme.breakpoints.down('lg')]: {
    height: '30px'
  }
}));

const Logo = ({ src, alt, dataTestId, logoLinkPath }) => {
  return (
    <Button href={logoLinkPath} data-testid="go-to-website">
      <StyledImage src={src} alt={alt} data-testid={dataTestId} />
    </Button>
  );
};

Logo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  logoLinkPath: PropTypes.string
};

export default Logo;
